import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { DEFAULT_SUBTAB, type Subtab } from '../../../../../../mini-apps/command-center/subtabs';

/**
 * The Flow tab (Accounts, Contacts, Plays, Signals) the rep last viewed.
 * `FlowShell` writes it whenever the Flow home route shows a tab, and the rail's
 * Flow item and logo read it, so leaving Flow and coming back lands on the same
 * tab instead of Accounts. Persisted so the choice survives a reload. It only
 * steers where the rail link goes: the `?tab=` URL param stays the source of
 * truth for what Flow shows.
 */
export interface FlowLastSubtabState {
  subtab: Subtab;
}

export const initialState: FlowLastSubtabState = {
  subtab: DEFAULT_SUBTAB,
};

export const useFlowLastSubtabStore = create<FlowLastSubtabState>()(
  persist(() => ({ ...initialState }), {
    name: 'flow-last-subtab',
    storage: createJSONStorage(() => localStorage),
  }),
);

export function setLastSubtab(subtab: Subtab): void {
  useFlowLastSubtabStore.setState({ subtab });
}

export function useLastSubtab(): Subtab {
  return useFlowLastSubtabStore((s) => s.subtab);
}
